module.exports = __webpack_public_path__ + "img/arrow.343e5b53.svg";